import { render, staticRenderFns } from "./TrainTask.vue?vue&type=template&id=c71cbc40&scoped=true&"
import script from "./TrainTask.vue?vue&type=script&lang=js&"
export * from "./TrainTask.vue?vue&type=script&lang=js&"
import style0 from "./TrainTask.vue?vue&type=style&index=0&id=c71cbc40&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c71cbc40",
  null
  
)

export default component.exports